import Jed from "jed";

const fr = {};
const en = {};
const es = {};

const ALLOWED_LOCALES = ["fr", "en", "es"];
const DEFAULT_LOCALE = "fr";

class I18n {
  constructor() {
    const locale = getLocale();

    if (locale === "fr") {
      this.jed = new Jed(fr);
    } else if (locale === "es") {
      this.jed = new Jed(es);
    } else {
      this.jed = new Jed({});
    }
  }

  translate(arg) {
    return this.jed.translate(arg);
  }

  load(json) {
    this.jed = new Jed(json);
  }

  default() {
    this.jed = new Jed({});
  }

  changeLanguage(language) {
    if (language === "fr") {
      setLocale(language);
    } else {
      setLocale(language);
    }

    window.location.reload();
  }
}

function replace(string, replacements) {
  for (let key in replacements) {
    string = string.replace(new RegExp(`{${key}}`, "gi"), replacements[key]);
  }

  return string;
}

const i18n = new I18n();

/*
 * I18nTranslate('key')
 * I18nTranslate('key {dog} foo', { dog })
 * I18nTranslate('key {count} {dog}', 'plural {count} {dog}', count, { dog, count })
 */
export function i18nTranslate(...args) {
  let value = i18n.translate(args[0]);

  if (args.length > 2) {
    value = value.ifPlural(args[2], args[1]).fetch(args[2]);

    return args.length === 4 ? replace(value, args[3]) : value;
  }

  value = value.fetch();

  return args.length === 2 ? replace(value, args[1]) : value;
}

export function getLocale(navigator = window.navigator) {
  let navLanguage = navigator.language || navigator.userLanguage;

  if (navLanguage.indexOf("-") !== -1)
    navLanguage = navLanguage.split("-")[0];

  if (navLanguage.indexOf("_") !== -1)
    navLanguage = navLanguage.split("_")[0];

  let savedLocale;

  try {
    savedLocale = localStorage.getItem("locale");
  } catch (e) {
    console.error(e);
  }

  const locale = savedLocale || navLanguage;

  if (ALLOWED_LOCALES.indexOf(locale) === -1)
    return DEFAULT_LOCALE;

  return locale;
}

export function setLocale(locale) {
  try {
    localStorage.setItem("locale", locale);
  } catch (e) {
    console.error(e);
  }
}

export function _t() {
  return i18nTranslate(...arguments);
}

export function _n() {
  return i18nTranslate(...arguments);
}

export function getBrowserLanguage() {
  const defaultLocales = ["fr", "en"];

  let navLang = (window?.navigator?.language || "en").toLowerCase().slice(0, 2);

  if (!defaultLocales.includes(navLang))
    navLang = "en";

  return navLang;
}

export default i18n;
